<template>
  <div>
    <dialog-v2 :show="show" :title="title" max-width="550px" @close="$emit('close')" @save="save">
      <template slot="title">
        <v-btn flat icon @click.stop="$emit('delete', {filter:pFilter, stage:pStage})">
              <v-icon color="red" small>
                fas fa-trash-alt
              </v-icon>
            </v-btn>
      </template>
      <template slot="content">
        <v-layout row wrap>
          <v-flex>
            <v-text-field v-model="form.name" v-validate="'required|max:100'" data-vv-name="name"
              data-vv-scope="paymentPFilter" data-vv-as="nombre" :error-messages="errors.collect('paymentPFilter.name')"
              label="Nombre" color="black" />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-text-field v-model="form.broken_promises" v-validate="'integer'" data-vv-name="broken_promises"
              data-vv-scope="paymentPFilter" data-vv-as="promesas rotas"
              :error-messages="errors.collect('paymentPFilter.broken_promises')" label="Promesas rotas" color="black" />
          </v-flex>
        </v-layout>
        <filters-list v-model="form.filters" :default-filters="form.filters" :key="filtersListKey" />
      </template>
    </dialog-v2>
    <template-dialog :show="templateDialog" :channel="templateChannel" :template="template"
      :append-vars="templateVars" validation-scope="pTemplate" validation-email-scope="pCompanyEmail"
      @save="saveTemplate" @close="templateDialog = false" />
    <test-template-dialog :show="testTemplateDialog" :template-id="(pFilter.template || {}).id || 0"
      :channel="templateChannelId" validation-scope="pTestTemplate" @close="testTemplateDialog = false" />
  </div>
</template>

<script>
import _ from 'lodash';
import TemplateDialog from '@/components/Templates/Index';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import DialogV2 from '@/components/global/DialogV2';
import FiltersList from '@/components/global/CustomerFilters/Index';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import EventBus from '@/event-bus';
import { setTimeout } from 'timers';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    pStage: {
      type: Object,
      required: true,
    },
    pFilter: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    DialogV2,
    FiltersList,
    TemplateDialog,
    TestTemplateDialog,
  },
  mixins: [
    channelsMixin,
    filtersMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      broken_promises: '',
      company_email_id: null,
      subject: '',
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_human: 0,
      email: '',
      sms: '',
      ivr: '',
      human: '',
      valid_only_sms: false,
      only_contacted_sms: false,
      filters: {
        type: 'group',
        operator: 'and',
        items: [],
      },
      sms_cs_journey: null,
      sms_check_days: null,
      sms_owner_id: null,
      ivr_owner_id: null,
      bot_owner_id: null,
      human_owner_id: null,
    };
    return {
      templateDialog: false,
      testTemplateDialog: false,
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: _.cloneDeep(emptyForm),
      filtersListKey: uuidv1(),
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.pFilter).length ? 'Crear' : 'Editar'} filtro`;
    },
    filteredChannels() {
      return this.channels.filter(item => ['email', 'sms', 'ivr', 'human'].includes(item.name));
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
  },
  methods: {
    testTemplate(id) {
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    saveTemplate(form) {
      this.form = {
        ...this.form,
        ...this.templateChannel === 'email' && {
          company_email_id: form.company_email_id,
          subject: form.subject,
        },
        [this.templateChannel]: form.text,
      };
    },
    save() {
      this.$validator.validateAll('paymentPFilter').then((validation) => {
        if (Object.keys(this.pFilter).length) {
          this.axios.patch(`payment_p_filters/${this.pFilter.id}`, {
            ..._.omit(this.form, 'filters'),
            filters: JSON.stringify(this.form.filters),
          })
            .then((response) => {
              this.$emit('updated', response.data);
              this.$emit('close');
            })
            .catch(() => { });
        } else {
          this.axios.post(`payment_p_stages/${this.pStage.id}/filters`, {
            ..._.omit(this.form, 'filters'),
            filters: JSON.stringify(this.form.filters),
          })
            .then((response) => {
              this.$emit('created', response.data);
              this.$emit('close');
            }).catch(() => { });
        }
      });
    },
  },
  watch: {
    show() {
      if (!Object.keys(this.pFilter).length) {
        setTimeout(() => {
          this.form = _.cloneDeep(this.emptyForm);
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.pFilter, Object.keys(this.emptyForm)),
        };
        if(typeof this.pFilter.filters === 'string') {
          this.form.filters = JSON.parse(this.pFilter.filters);
        }
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.remove('name', 'paymentPFilter');
        }, 500);
      }
      this.filtersListKey = uuidv1();
    },
  },
};
</script>

<style scoped>
.btn.channels-btn {
  width: 50px;
  height: 50px;
}

.custom-checkbox {
  width: 210px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/PaymentPromiseTree/PFilterModalV2.vue